import { withStyles } from '@material-ui/core/styles';
import { TableCell, Theme } from '@material-ui/core';

export const PasslyTableCell = withStyles((theme: Theme) => ({
    root: {
        height: 50,
        border: 'none',
        padding: '0 16px'
    }
}))(TableCell);
